import { MapPin } from 'lucide-react'
import { Link } from 'react-router-dom'
import logo from '@/assets/logo.jpg'
import WhatsAppIcon from '@/components/icons/WhatsAppIcon'
import SocialLinks from '@/components/SocialLinks'
import NavItem from './NavItem'
import { WHATSAPP_URL, MAPS_URL } from '@/data/contact'
import { NAV_LINKS_FOOTER } from '@/data/navigationFooter'

export default function Footer() {
  const year = new Date().getFullYear()

  return (
    <footer className="bg-cmp-navy-dark text-white/70">
      <div className="max-w-6xl mx-auto px-6 lg:px-8 py-14 grid gap-10 sm:grid-cols-2 lg:grid-cols-4">
        <div>
          <Link to="/" className="flex items-center gap-2.5">
            <img src={logo} alt="CMP Lubumbashi" className="h-10 w-10 rounded-full object-cover ring-2 ring-white/15" />
            <span className="font-bold text-white text-sm leading-tight">
              CMP
              <br />
              <span className="font-normal text-cmp-sky text-xs">Lubumbashi</span>
            </span>
          </Link>
          <p className="text-sm leading-relaxed mt-4 max-w-xs">
            Une porte ouverte pour tous. Venez comme vous êtes, vous êtes attendu.
          </p>
        </div>

        <div>
          <p className="text-white text-sm font-bold uppercase tracking-wide mb-4">Navigation</p>
          <ul className="space-y-2.5 text-sm">
            {NAV_LINKS_FOOTER.map((link) => (
              <li key={link.label}>
                <NavItem {...link} className="hover:text-cmp-gold-light transition-colors" />
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-white text-sm font-bold uppercase tracking-wide mb-4">Nous contacter</p>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2.5">
              <MapPin size={16} className="shrink-0 mt-0.5 text-cmp-gold-light" />
              <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" className="hover:text-cmp-gold-light transition-colors">
                17 Avenue Nyangwe I, Quartier Lido, Commune de Lubumbashi Lubumbashi
              </a>
            </li>
            <li className="flex items-start gap-2.5">
              <WhatsAppIcon size={16} />
              <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="hover:text-cmp-gold-light transition-colors">
                Nous écrire sur WhatsApp
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-white text-sm font-bold uppercase tracking-wide mb-4">Suivez-nous</p>
          <SocialLinks className="flex-wrap" />
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-6 lg:px-8 py-5 text-xs text-white/40 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p>© {year} Centre Missionnaire Philadelphie Lubumbashi. Tous droits réservés.</p>
          {/* <p>Fait avec foi, pour la communauté.</p> */}
        </div>
      </div>
    </footer>
  )
}
